var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStethoscope(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5034_597",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.320312,
    y: 0.0302734,
    width: 39.0525,
    height: 39.0525,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5034_597)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2869 35.8284C19.3579 35.8284 16.8629 34.7979 14.8018 32.7368C12.7407 30.6757 11.7102 28.1806 11.7102 25.2517V24.3161C9.37785 23.9364 7.43879 22.8448 5.89296 21.0413C4.34713 19.2379 3.57422 17.1158 3.57422 14.675V4.91186H8.45578V3.28467H11.7102V9.79342H8.45578V8.16623H6.82859V14.675C6.82859 16.4649 7.46591 17.9972 8.74054 19.2718C10.0152 20.5464 11.5474 21.1837 13.3373 21.1837C15.1272 21.1837 16.6595 20.5464 17.9341 19.2718C19.2088 17.9972 19.8461 16.4649 19.8461 14.675V8.16623H18.2189V9.79342H14.9645V3.28467H18.2189V4.91186H23.1005V14.675C23.1005 17.1158 22.3276 19.2379 20.7817 21.0413C19.2359 22.8448 17.2968 23.9364 14.9645 24.3161V25.2517C14.9645 27.2857 15.6764 29.0146 17.1002 30.4384C18.524 31.8621 20.2529 32.574 22.2869 32.574C24.3209 32.574 26.0497 31.8621 27.4735 30.4384C28.8973 29.0146 29.6092 27.2857 29.6092 25.2517V22.5262C28.66 22.2007 27.8803 21.6176 27.2701 20.7769C26.6599 19.9362 26.3548 18.987 26.3548 17.9294C26.3548 16.5734 26.8294 15.4208 27.7786 14.4716C28.7278 13.5224 29.8804 13.0478 31.2364 13.0478C32.5924 13.0478 33.745 13.5224 34.6942 14.4716C35.6434 15.4208 36.118 16.5734 36.118 17.9294C36.118 18.987 35.8129 19.9362 35.2027 20.7769C34.5925 21.6176 33.8128 22.2007 32.8636 22.5262V25.2517C32.8636 28.1806 31.833 30.6757 29.7719 32.7368C27.7108 34.7979 25.2158 35.8284 22.2869 35.8284ZM31.2364 19.5565C31.6974 19.5565 32.0839 19.4006 32.3958 19.0887C32.7076 18.7768 32.8636 18.3904 32.8636 17.9294C32.8636 17.4683 32.7076 17.0819 32.3958 16.77C32.0839 16.4581 31.6974 16.3022 31.2364 16.3022C30.7754 16.3022 30.3889 16.4581 30.077 16.77C29.7652 17.0819 29.6092 17.4683 29.6092 17.9294C29.6092 18.3904 29.7652 18.7768 30.077 19.0887C30.3889 19.4006 30.7754 19.5565 31.2364 19.5565Z",
    fill: "#EA7F4A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStethoscope);
export default __webpack_public_path__ + "static/media/stethoscope.b7d45b3e2182f74abc005e0734268835.svg";
export { ForwardRef as ReactComponent };